import { Link } from "react-router";

export default function NotFound() {
  return (
    <div className="min-h-[100dvh] flex items-center justify-center pt-16 px-6">
      <div className="text-center max-w-md">
        <h1 className="font-heading text-h1 text-text-primary mb-4">Page not found</h1>
        <p className="font-body text-body text-text-secondary mb-6">
          The page you're looking for doesn't exist.
        </p>
        <Link
          to="/"
          className="font-heading text-sm font-medium bg-accent-cyan text-bg-primary px-5 py-2.5 rounded-md hover:bg-accent-hover hover:scale-[1.03] hover:shadow-glow transition-all duration-200 no-underline inline-block"
        >
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
}
